// src/ones/OnePastor.js
import { useContext } from "react"
import { AppContext } from "../App"
import { MdPerson, MdPlace, MdChurch } from "react-icons/md";

export default function OnePastor(props) {

  const appContext = useContext(AppContext);

  const pastor = props.pastor || {};

  return (
    <div
      className="mShadow2"
      style={{
        width: "100%",
        borderRadius: "22px",
        overflow: "hidden",
        background: "rgba(244,244,244,0.80)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        border: "1px solid rgba(0,0,0,0.06)",
        marginBottom: "14px",
        padding: "14px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div
          className="mShadow1"
          style={{
            width: "52px",
            height: "52px",
            borderRadius: "18px",
            background: "rgba(255,255,255,0.65)",
            border: "1px solid rgba(0,0,0,0.06)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <MdPerson className="text-primary" size={30} />
        </div>

        <div style={{ flexGrow: 1, minWidth: 0 }}>
          <h6
            className="mNoMargin font-semi-bold mOneLineText"
            style={{
              fontSize: "15px",
            }}
          >
            {pastor.fullname || "Pastor"}
          </h6>

          <div style={{ marginTop: "6px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <MdChurch className="text-secondary" size={16} />
              <p
                className="mNoMargin font-regular mOneLineText"
                style={{
                  fontSize: "13px",
                  opacity: 0.8,
                }}
              >
                {pastor.church || ""}
              </p>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "4px" }}>
              <MdPlace className="text-secondary" size={16} />
              <p
                className="mNoMargin font-regular mOneLineText"
                style={{
                  fontSize: "13px",
                  opacity: 0.8,
                }}
              >
                {pastor.location || ""}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
